import { Puzzle, Settings } from 'lucide-react';
import type { NavItem } from '@os/ui';

/** Host chrome on every OS app (§73). Addon nav is inserted before this group (`mergeAddonNav`). */
export const APP_NAV: NavItem[] = [
  { group: 'App' },
  { to: '/settings/addons', label: 'Add-ons', icon: Puzzle, end: true },
  { to: '/settings', label: 'Settings', icon: Settings, end: true },
];
